import React, { FunctionComponent } from 'react';
import { Link } from '@visalex/core';

import cx from 'clsx';

import { PostWithPath } from '../../types';

import styles from './MostFrequentlyAsked.module.scss';

export type MostFrequentlyAskedProps = { posts: PostWithPath[]; currentPath: string };

export const MostFrequentlyAsked: FunctionComponent<MostFrequentlyAskedProps> = ({ posts, currentPath }) => {
  return (
    <section className={styles['faq__most-frequently-asked']}>
      <h4 className={styles['faq__most-frequently-asked_header']}>The Most Popular Questions</h4>
      <div data-testid="most-frequently-asked">
        {posts &&
          posts.map((post: PostWithPath, id: number) => (
            <Link
              key={id}
              href={`/help${post.path}`}
              className={cx(styles['faq__most-frequently-asked_link'], {
                [styles['faq__most-frequently-asked_link--active']]: currentPath === post.path,
              })}
            >
              <img src="/icons/form.svg" />
              <h4 data-testid="most-frequently-title">{post.post.title}</h4>
            </Link>
          ))}
      </div>
    </section>
  );
};
